"use strict";
var __importDefault = (this && this.__importDefault) || function (mod) {
    return (mod && mod.__esModule) ? mod : { "default": mod };
};
Object.defineProperty(exports, "__esModule", { value: true });
exports.GenericMenuItemGrid = void 0;
const react_1 = __importDefault(require("react"));
const GenericMenuItem_1 = require("./GenericMenuItem");
const colorTable_1 = __importDefault(require("../../../shared/colorTable"));
function GenericMenuItemGrid({ items, updateSelectedItem }) {
    const [selectedItemIndex, setSelectedItemIndex] = react_1.default.useState(0);
    const [hoverItemIndex, setHoverItemIndex] = react_1.default.useState(undefined);
    return items.map((item, index) => {
        let backgroundColor = '#363C47';
        if (selectedItemIndex == index) {
            backgroundColor = '#FFD522';
        }
        else if (hoverItemIndex == index) {
            backgroundColor = '#E7CAB2';
        }
        let borderColor = colorTable_1.default.rarityInfo['uncommon'].loadoutBorder;
        if (item.borderColor) {
            borderColor = item.borderColor;
        }
        else if (item.rarity) {
            borderColor = colorTable_1.default.rarityInfo[item.rarity].loadoutBorder;
        }
        return react_1.default.createElement(GenericMenuItem_1.GenericMenuItem, { imgPath: item.imgPath, backgroundColor: backgroundColor, borderColor: borderColor, onClick: (e) => {
                updateSelectedItem(item, index);
                setSelectedItemIndex(index);
            }, onMouseOver: () => {
                if (selectedItemIndex !== index) {
                    setHoverItemIndex(index);
                }
            }, onMouseOut: () => {
                if (hoverItemIndex === index) {
                    setHoverItemIndex(undefined);
                }
            } });
    });
}
exports.GenericMenuItemGrid = GenericMenuItemGrid;
